import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import {
  ImportOptionExerciseService,
  ImportOptionExerciseSharedService,
  OptionExerciseService,
  Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseDto,
  Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '../../services/wealthlane-award-services';
import { useNavigate } from 'react-router-dom';
import ToastComponent from '../../components/toast';

const usePostOptionExerciseSubmit = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  // eslint-disable-next-line camelcase
  any | undefined,
  unknown,
  void,
  unknown
> => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        ImportOptionExerciseSharedService.postApiAwardApiAppImportOptionExerciseOptionExerciseRequest(
          payload
        )
      );
    },
    {
      // eslint-disable-next-line camelcase
      onSuccess: (response: any) => {
        if (response.success) {
          toast.success(<ToastComponent label='Success' message={`Option exercise requested.`} />);
          void queryClient.invalidateQueries('getParticipantDashboardTaskSummery');
          void queryClient.invalidateQueries('getParticipantDashboardTask');
          navigate('/holdings');
        } else if (!response.success) {
          toast.success(<ToastComponent label='Error' message={`${response?.message[0]}`} />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostOptionExerciseSubmit;
